import React from 'react'
import { useIntl } from 'react-intl'
import BodyText from 'LuxKit/Typography/BodyText'
import Caption from 'LuxKit/Typography/Caption'
import Heading from 'LuxKit/Typography/Heading'
import styled from 'styled-components'
import { rem } from 'polished'
import LayoutContainer from 'components/Common/LayoutContainer'
import TextLink from 'LuxKit/TextLink'
import { EmptyArray } from 'lib/array/arrayUtils'

const RelatedItemsGrid = styled(LayoutContainer)`
  margin-top: ${rem(32)};
  padding-bottom: ${rem(32)};
`

const RelatedItems = styled(Caption)`
  margin-top: ${rem(16)};  

  > * + * {
    margin-left: ${rem(8)}
  }
`

interface Props {
  items?: Array<{ text: string, url: { to: string } }>
  title?: string
}

function RelatedTravelItems({ items = EmptyArray, title }: Props) {
  const intl = useIntl()

  const defaultTitle = intl.formatMessage({
    id: 'aMuZ47u+Se',
    defaultMessage: 'Related Travel',
    description: 'Default heading for related travel items section on offer page',
  })

  return <RelatedItemsGrid>
    <Heading variant="heading6">{title || defaultTitle}</Heading>
    <RelatedItems variant="medium">
      {items.map((item, index) => <React.Fragment key={item.text}>
        {index > 0 && <BodyText variant="large" colour="neutral-four" as="span">&nbsp;| </BodyText>}
        <TextLink weight="regular"to={item.url.to}>{item.text}</TextLink>
      </React.Fragment>,
      )}
    </RelatedItems>
  </RelatedItemsGrid>
}

export default React.memo(RelatedTravelItems)
